import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoreModule } from '@xanadu/core';

import { DialogComponent } from './dialog/dialog.component';
import { OkayComponent } from './okay/okay.component';

@NgModule({
    declarations: [
        DialogComponent,
        OkayComponent
    ],
    imports: [
        CommonModule,
        CoreModule
    ],
    exports: [
        DialogComponent,
        OkayComponent,
    ],
    providers: [
    ]
})
export class SupportModule { }
export * from './dialog/dialog.component';
export * from './okay/okay.component';
export * from './model/consent';
export * from './model/reply';
